import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";

const CustomButton = ({
  text,
  icon,
  iconPosition = "left",
  width = "auto",
  onClick,
  className = "",
  disabled = false,
  loading = false,
  style = {},
  variant = "contained",
  color = "primary",
  children,
  type = "button",
  size = "medium",
  ...otherProperties
}) => {
  return (
    <Button
      {...otherProperties}
      onClick={onClick}
      className={className}
      disabled={disabled || loading}
      style={{ width, ...style }}
      variant={variant}
      size={size}
      color={color}
      startIcon={icon && iconPosition === "left" && !loading ? icon : null}
      endIcon={icon && iconPosition === "right" && !loading ? icon : null}
      type={type}
    >
      {loading ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        children || text
      )}
    </Button>
  );
};

CustomButton.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  style: PropTypes.object,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  color: PropTypes.oneOf([
    "inherit",
    "primary",
    "secondary",
    "success",
    "error",
    "info",
    "warning",
  ]),
  children: PropTypes.node,
};

export default CustomButton;
